/**
 * What a figure printed before a press is drawn from, heard as it moves (D311).
 *
 * A figure is drawn from this browser's record of passes (`core/passDraw.ts`) at
 * the level its kind of work is set to (D313), so it moves when a pass lands,
 * when another tab adds one, and when a level is set — none of which a
 * surface's own selectors are guaranteed to hear. A surface that prints such a
 * figure calls this beside `useVoiceOn`, for the reason that one exists: to
 * re-read the figure when what it is drawn from moves, rather than show the old
 * one until some other change happens to render it again.
 */

import { useSyncExternalStore } from 'react'
import { onPassDrawsChange, passDrawsVersion } from '../core/passDraw'
import { useStore } from '../core/store'

export function useFigureBasis(): void {
  useSyncExternalStore(onPassDrawsChange, passDrawsVersion, passDrawsVersion)
  useStore((s) => s.effortLevels)
}
